/**
 * Adresa API pro veřejný web.
 *
 * Web běží od 24. 10. 2026 na www.sobacov.cz (statický hosting Machin/Forpsi),
 * ale backend zůstává na sobacov.nfi-iq.cz. Relativní `/api/...` by tam
 * skončilo 404, proto všechna volání jdou přes apiUrl() a základ se nastaví
 * při buildu: VITE_API_BASE=https://sobacov.nfi-iq.cz npm run build.
 * Bez proměnné (lokální vývoj, sobacov.nfi-iq.cz) zůstává relativní cesta.
 */
export const API_BASE: string = (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/+$/, '') || ''

export function apiUrl(path: string): string {
  return `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`
}

/** Fotky nahrané v appce chodí jako `/files/sobacov/…` — ty leží u backendu, ne u webu. */
export function assetUrl(u: string | undefined | null): string | undefined {
  if (!u) return undefined
  if (/^https?:\/\//.test(u) || u.startsWith('data:')) return u
  return u.startsWith('/files/') ? `${API_BASE}${u}` : u
}
